import { render, staticRenderFns } from "./nf-interval.vue?vue&type=template&id=0481bab2&scoped=true"
import script from "./nf-interval.vue?vue&type=script&lang=js"
export * from "./nf-interval.vue?vue&type=script&lang=js"
import style0 from "./nf-interval.vue?vue&type=style&index=0&id=0481bab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481bab2",
  null
  
)

export default component.exports